"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _RawText = _interopRequireDefault(require("./RawText"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextSt = require("./Text.st.css");

var _Ellipsis = _interopRequireWildcard(require("../common/Ellipsis"));

var _TooltipCommon = require("../common/PropTypes/TooltipCommon");

var _excluded = ["className", "tooltipProps"];

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Text/Text.js",
    _this = void 0;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TextWithEllipsis = function TextWithEllipsis(_ref) {
  var className = _ref.className,
      tooltipProps = _ref.tooltipProps,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);

  var _extractEllipsisProps = (0, _Ellipsis.extractEllipsisProps)(props),
      ellipsisProps = _extractEllipsisProps.ellipsisProps,
      componentProps = _extractEllipsisProps.componentProps;

  return /*#__PURE__*/_react["default"].createElement(_Ellipsis["default"], (0, _extends2["default"])({}, ellipsisProps, tooltipProps, {
    wrapperClassName: (0, _TextSt.st)(_TextSt.classes.root, {
      size: props.size,
      weight: props.weight,
      listStyle: props.listStyle
    }),
    render: function render(_ref2) {
      var ref = _ref2.ref,
          ellipsisClasses = _ref2.ellipsisClasses,
          ellipsisInlineStyle = _ref2.ellipsisInlineStyle;
      return /*#__PURE__*/_react["default"].createElement(_RawText["default"], (0, _extends2["default"])({}, componentProps, {
        ref: ref,
        className: ellipsisClasses(className),
        style: ellipsisInlineStyle,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 20,
          columnNumber: 9
        }
      }));
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 5
    }
  }));
};

TextWithEllipsis.displayName = 'Text';
TextWithEllipsis.propTypes = {
  /*
   * Text props
   */

  /** Applies a data-hook HTML attribute that can be used in the tests. */
  dataHook: _propTypes["default"].string,

  /** Specifies a CSS class name to be appended to the component’s root element. */
  className: _propTypes["default"].string,

  /** Defines a tag name that text should be rendered inside of (e.g., div, a, p). */
  tagName: _propTypes["default"].string,

  /** Controls the font size of the text. */
  size: _propTypes["default"].oneOf(['tiny', 'small', 'medium']),

  /** Renders any kind of content within a heading. Usually it’s a text string. */
  children: _propTypes["default"].any,

  /** Sets text type to secondary. Affects font color only. */
  secondary: _propTypes["default"].bool,

  /** Controls the skin of the text. */
  skin: _propTypes["default"].oneOf(['standard', 'success', 'error', 'premium', 'disabled', 'primary']),

  /** Sets list items style. */
  listStyle: _propTypes["default"].oneOf(['checkmark', 'circle']),

  /** Inverts text color so it can be used on dark backgrounds. */
  light: _propTypes["default"].bool,

  /** Controls the font weight of the text. */
  weight: _propTypes["default"].oneOf(['thin', 'normal', 'bold']),

  /** Applies id HTML attribute. */
  id: _propTypes["default"].string,

  /*
   * Ellipsis props
   */

  /** Truncates text that is longer than its parent container and displays ellipsis at the end of the last line. */
  ellipsis: _propTypes["default"].bool,

  /** Specifies whether to show a tooltip for ellipsis.  */
  showTooltip: _propTypes["default"].bool,

  /** Specifies tooltip content z index. */
  zIndex: _propTypes["default"].number,

  /** Defines tooltip placement in relation to target element. */
  placement: _propTypes["default"].string,

  /** Disables tooltip element trigger. If not specified, disabled prop value of the children element will be used. */
  disabled: _propTypes["default"].bool,

  /** Defines a tooltip content calculation relation to a dom element. */
  appendTo: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['window', 'scrollParent', 'viewport', 'parent']), _propTypes["default"].element, _propTypes["default"].func]),

  /** Flips tooltip placement when it starts to overlap the target element. */
  flip: _propTypes["default"].bool,

  /** Keeps tooltip at its original placement even when it's being positioned outside the boundary. */
  fixed: _propTypes["default"].bool,

  /** Specifies time to wait before showing the tooltip in milliseconds. */
  enterDelay: _propTypes["default"].number,

  /** Specifies time to wait before hiding the tooltip in milliseconds. */
  exitDelay: _propTypes["default"].number,

  /** Specifies tooltip width in pixels. */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** Defines a callback function which is called every time tooltip is shown. */
  onShow: _propTypes["default"].func,

  /** Defines a callback function which is called every time tooltip is hidden. */
  onHide: _propTypes["default"].func,

  /** Moves tooltip content relative to the parent on X or Y axis. */
  moveBy: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),

  /** Moves tooltip arrow by a specified amount. */
  moveArrowTo: _propTypes["default"].number,

  /** Controls tooltip content alignment on X axis. */
  textAlign: _propTypes["default"].oneOf(['start', 'center']),

  /** Allows to pass all common tooltip props. Check <Tooltip/> for a full API. */
  tooltipProps: _propTypes["default"].shape(_TooltipCommon.TooltipCommonProps)
};
TextWithEllipsis.defaultProps = _objectSpread(_objectSpread({}, _RawText["default"].defaultProps), _Ellipsis["default"].defaultProps);
var _default = TextWithEllipsis;
exports["default"] = _default;
//# sourceMappingURL=Text.js.map